import React, { Component } from "react";
import { connect } from "react-redux";

import { APP_ENV } from "Config";
import TTPArticleWidget from "./NewCommunity/Article/TTPArticleWidget";

export class Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articleWidgetLoaded: false
    };
    this.handleArticles = this.handleArticles.bind(this);
  }

  componentDidMount() {
    this.installWidget();
  }

  installWidget() {
    const widgetScriptExist = document.getElementById(`TTP_WIDGET_SCRIPT`);
    if (!widgetScriptExist) {
      var widgetStyle = document.createElement("link");
      widgetStyle.id = "TTP_WIDGET_STYLE";
      widgetStyle.rel = "stylesheet";
      widgetStyle.type = "text/css";
      widgetStyle.href = `https://tamtam.s3-eu-west-1.amazonaws.com/cdn/widget/${APP_ENV}/static/css/widget.css`;
      document.getElementsByTagName("HEAD")[0].appendChild(widgetStyle);

      // this.removeWidget();
      const widgetScript = document.createElement("script");
      widgetScript.id = "TTP_WIDGET_SCRIPT";

      widgetScript.setAttribute(
        "src",
        `https://tamtam.s3-eu-west-1.amazonaws.com/cdn/widget/${APP_ENV}/static/js/widget.js`
      );
      const that = this;
      widgetScript.onload = function() {
        if (!that.state.articleWidgetLoaded) {
          this.setState({ articleWidgetLoaded: true });
        }
      }.bind(this);
      // this.setState({ articleWidgetLoaded: true });
      document.body.appendChild(widgetScript);
    } else {
      if (!this.state.articleWidgetLoaded) {
        this.setState({ articleWidgetLoaded: true });
      }
    }
  }

  removeWidget() {
    // Remove Widget script tag
    const widgetScript = document.querySelector(`#TTP_WIDGET_SCRIPT`);
    widgetScript && widgetScript.parentNode.removeChild(widgetScript);

    // const widgetStyle = document.querySelector(`#TTP_WIDGET_STYLE`);
    // widgetStyle && widgetStyle.parentNode.removeChild(widgetStyle);

    // Remove Widget
    // const widget = document.querySelector(`.${TALK_WIDGET}`);
    // widget && widget.parentNode.removeChild(widget);
  }

  handleArticles(articles) {
    if (articles.length > 0) {
    }
  }

  render() {
    const { widgets, auth, drawerIframe } = this.props;
    const { articleWidgetLoaded } = this.state;

    return articleWidgetLoaded ? (
      drawerIframe.isOpen && drawerIframe.appType === "BLOG" ? (
        <TTPArticleWidget
          lng={"fr"}
          auth={auth}
          article={widgets.includes("ARTICLE")}
          tamtamit={widgets.includes("TAMTAMIT")}
          selectArticles={articles => this.handleArticles(articles)}
        />
      ) : null
    ) : null;
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth,
  user: state.auth.user,
  community: state.auth.navCommunity,
  loggedAs: state.auth.loggedAs,
  currentPortal: state.auth.currentPortal,
  selectedLayout: state.auth.selectedLayout,
  drawerIframe: state.params.drawerIframe
});

export default connect(mapStateToProps)(Widget);



// WEBPACK FOOTER //
// ./src/components/Community/Widget.js